import styled from 'styled-components';
import Icon from '../../assets/images/document-sign-icon.svg';

const SignIcon = styled.span`
  background: url(\"${Icon}\") no-repeat left center;
  background-size: 22px 22px;
  display: inline-block;
  position: relative;
  width: 22px;
  height: 22px;
  margin-right: 10px;
  margin-top: 3px;
`;

export default SignIcon;
